
export function logOutRedirectCall(){
  sessionStorage.clear()
  }
  
 
